<template>
  <div class="container" v-if="categories !== null">
    <h2>{{ niceCategory }}</h2>
    <section class="section">
      <div class="columns is-multiline">
        <div class="column is-one-third is-one-quarter-desktop" :key="category.id" v-for="category in categories" @click="$router.push('/shop' + $route.path + '/' + encodeURIComponent(category.name.toLowerCase().replace(new RegExp(' ', 'g'), '-')))">
          <card class="secondary-categories" hoverable>
            <div class="card-image" v-if="category.imageId !== null">
              <div class="image is-square">
                <img :src="BASE_URL + '/images/' + category.imageId + '/large'">
              </div>
            </div>
            <div class="card-content">
              <div class="content">
                <h3>{{ category.name }}</h3>
              </div>
            </div>
          </card>
        </div>
      </div>
    </section>
  </div>
  <loader v-else></loader>
</template>

<script>
import Loader from './Loader';
import Card from './Card';
import { BASE_URL } from '../http';
import { HTTP } from '../http';
import Breadcrumb from './Breadcrumb.vue';

export default {
  components: {
    Card,
    Loader,
  },
  name: 'shop-categories',

  data() {
    return {
      categories: [],
    };
  },

  watch: {
    $route() {
      this.load();
    },
  },

  created() {
    this.load();
  },

  computed: {
    BASE_URL() {
      return BASE_URL;
    },

    niceCategory() {
      return this.$route.path.replace(new RegExp('-', 'g'), ' ').substring(1);
    },
  },

  methods: {
    load() {
      this.$store.commit('progress/start');

      HTTP.get('/categories/' + encodeURIComponent(this.getCategories().join(',')))
        .then((resp) => (this.categories = resp.data))
        .then(() => this.$store.commit('progress/stop'));
    },

    getCategories() {
      switch (this.$route.path) {
        case '/weddings-&-events':
          return ['weddings', 'bar/bat mitzvah', 'corporate/gala'];
        case '/holiday':
          return ["valentine's day", 'easter & passover', "mother's day", 'rosh hashanah', 'thanksgiving', 'christmas'];
        case '/everyday':
          return ['birthday', 'love & romance', 'thank you & congratulations', 'get well', 'sympathy', 'new baby'];
        default:
          console.warn('Returning nonexistant category');
          return [];
      }
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ShopCategories.vue